import { render, staticRenderFns } from "./editCintura.vue?vue&type=template&id=5761b4ce&"
import script from "./editCintura.vue?vue&type=script&lang=ts&"
export * from "./editCintura.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports